// eslint-disable-next-line no-shadow
enum PrinterType {
  MACHINE,
  BLUETOOTH,
  USB110,
  WHATSAPP,
  USB100,
}
export default PrinterType;
